import React, { FunctionComponent } from 'react';
import { Range, getTrackBackground, Direction } from 'react-range';
import styled, { css } from 'styled-components';
import { Colors } from '@inplayer-org/inplayer-ui';

const RangeContainer = styled.div<{ direction: Direction }>`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  height: ${({ direction }) => (direction === Direction.Down ? '100%' : '')};
`;

const LineContainer = styled.div<{ direction: Direction }>`
  display: flex;
  ${({ direction }) =>
    direction === Direction.Right
      ? css`
          height: 4rem;
          width: 100%;
        `
      : css`
          width: 4rem;
          flex-direction: column;
          height: 100%;
        `}
`;

interface LineProps {
  background: string;
  direction: Direction;
}

const Line = styled.div<LineProps>`
  height: ${({ direction }) => (direction === Direction.Down ? '100%' : '0.3rem')};
  width: ${({ direction }) => (direction === Direction.Right ? '100%' : '0.3rem')};
  border-radius: 4px;
  align-self: center;
  background: ${({ background }: LineProps) => background};
`;

const CircleThumb = styled.div`
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 50%;
  background-color: ${Colors.white};
  box-shadow: 0px 2px 6px ${Colors.darkGray};
`;

type Props = {
  min: number;
  max: number;
  step: number;
  sliderColors: Array<string>;
  values: Array<number>;
  setValues: (values: Array<number>) => void;
  direction: Direction;
};

const Slider: FunctionComponent<Props> = ({ min, max, setValues, values, step, sliderColors, direction }: Props) => {
  const handleSliderChange = (changedValues: number[]) => {
    setValues(changedValues);
  };

  return (
    <RangeContainer direction={direction}>
      <Range
        values={values}
        step={step}
        min={min}
        max={max}
        onChange={handleSliderChange}
        direction={direction}
        renderTrack={({ props, children }) => (
          <LineContainer direction={direction} onMouseDown={props.onMouseDown} onTouchStart={props.onTouchStart}>
            <Line
              direction={direction}
              ref={props.ref}
              background={getTrackBackground({
                values,
                colors: sliderColors,
                min,
                max,
                direction,
              })}
            >
              {children}
            </Line>
          </LineContainer>
        )}
        renderThumb={({ props }) => <CircleThumb {...props} />}
      />
    </RangeContainer>
  );
};

export default Slider;
